module.exports = __webpack_public_path__ + "static/Buttons.ebfd8410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Buttons.jpg
// module id = 387
// module chunks = 65579394461380